'use strict';

import React, { Component } from 'react'

import Link from '@Pure/Link'

const { app } = window;

export default class PageTitle extends Component
{
	state =
	{
		permissions:
		{
			title: 'not_auth'
		}
	};

	componentDidMount ()
	{
		const component = this, props = this.props;

		app.push(
		{
			event: 'sessionChange',
			cb: component.handleSessionChange
		});

		component.handleSessionChange();
	}

	componentWillUnmount ()
	{
		const component = this, props = this.props;

		app.delete(
		{
			event: 'sessionChange',
			cb: component.handleSessionChange
		});
	}

	handleSessionChange = () =>
	{
		const component = this, props = this.props;

		component.setState(
		{
			permissions: app.state.session.permissions
		});
	}

	render ()
	{
		const component = this, props = this.props, state = this.state;

		var pathname = props.history.location.pathname.split('/');
		var breadcrumb_elements = [], link = '', key = 0;

		if (props.history.location.pathname === '/dashboard')
		{
			pathname = ['/dashboard'];
		}
		else if (props.pathname)
		{
			pathname = props.pathname.split('/');
		}

		pathname.forEach(function (url_slug, index)
		{
			if (index !== 1)
			{
				link += '/';
			}

			if (index > 0)
			{
				breadcrumb_elements.push
				(
					<div className="c-breadcrumb__separator" key={ key }></div>
				);

				key++;
			}

			var class_name = 'c-breadcrumb__element';

			if (index === pathname.length-1)
			{
				class_name += ' active';

				url_slug = props.title || url_slug;
			}

			let home_link = '/accueil', permissions = component.state.permissions;

			if (['Membre de synergies'].includes(permissions.title))
			{
				home_link = '/dashboard';
			}
			else if (permissions.title === 'Partenaire')
			{
				home_link = '/espace-partenaires';
			}

			let label = url_slug.split('-').join(' ');

			if (index === 0)
			{
				breadcrumb_elements.push
				(
					<Link href={ home_link } className={ class_name } key={ key }>
						<svg className="o-svg-icon o-svg-icon--home">
							<use xlinkHref="/images/icons.svg#svg-icon-home"></use>
						</svg>
					</Link>
				);
			}
			else if ((link + url_slug !== '/accueil') ||
				['Membre de synergies', 'Partenaire'].includes(permissions.title))
			{
				let item_link = link;

				if (url_slug === 'espace-partenaires')
				{
					label = 'Encore + d\'avantages';
				}

				if (index === pathname.length-1)
				{
					item_link = undefined;
				}
				else if (url_slug === 'mon-espace' && index === 2)
				{
					item_link = '/accueil';

					label = 'Accueil';
				}
				else if (url_slug === 'blog' && index === 3)
				{
					label = 'Infos & actus';

					item_link += url_slug;
				}
				else
				{
					item_link += url_slug;
				}

				breadcrumb_elements.push
				(
					<Link href={ item_link } className={ class_name } key={ key }>
						{ label }
					</Link>
				);
			}

			link += url_slug;

			key++;
		});

		if (state.permissions.title === 'Partenaire')
		{
			breadcrumb_elements = breadcrumb_elements[0];
		}

		let title;

		if (props.title && props.hide_title !== true)
		{
			title =
			(
				<h1 className="c-page-title__txt">
					{ props.title }
				</h1>
			);
		}

		var output =
		(
			<header className={ 'c-page-title' + (props.title && props.hide_title !== true ?
				'' : ' c-page-title--breadcrumb-only') }>

				{ title }

				{
					props.hide_breadcrumb !== true ?
					(
						<div className="c-breadcrumb">
							<ol className="c-breadcrumb__list">
								{ breadcrumb_elements }
							</ol>
						</div>
					)
					: undefined
				}

			</header>
		);

		return output;
	}
}